import { useContext } from 'react'

import { ImportReferralsContext } from '@/contexts/ImportReferralsContext'

const useImportReferralsContext = () => useContext(ImportReferralsContext)

export default useImportReferralsContext
